export const getArtifactDetailsPath = (artifactId: string): string => {
    return `/BuildStatus/Artifact/${artifactId}`;
};
export const getBuildDetailsPath = (
    buildInstanceCorrelationId: string
): string => {
    let url = `/BuildStatus/Build/${buildInstanceCorrelationId}`;
    return url;
};

export const getAdoRepoUrl = (
    accountName: string,
    projectName: string,
    repositoryName: string
): string => {
    let url: string = process.env.REACT_APP_ADO_URL_REPO || '';
    url = url.replace('{accountName}', accountName ? accountName : '');
    url = url.replace('{projectName}', projectName ? projectName : '');
    url = url.replace('{repoName}', repositoryName ? repositoryName : '');
    return url;
};
